import { Variant } from './PriceText';

const SMALL_LENGTH_THRESHOLD = 14;

export const needsSmallVariant = (variant, numberFormatted) =>
  variant === Variant.PaymentTotal &&
  numberFormatted.length >= SMALL_LENGTH_THRESHOLD;
